import { render, staticRenderFns } from "./SickLeavePolicyList.vue?vue&type=template&id=2327707e&scoped=true&"
import script from "./SickLeavePolicyList.vue?vue&type=script&lang=ts&"
export * from "./SickLeavePolicyList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2327707e",
  null
  
)

export default component.exports